module.exports = __webpack_public_path__ + "static/img/ARAD2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD2_1.png
// module id = bPEb
// module chunks = 0